export default {
  // Navbar
  'nav.features': '기능',
  'nav.technology': '기술',
  'nav.useCases': '활용 사례',
  'nav.demo': '데모',
  'nav.contact': '문의',
  'nav.docs': '문서',

  // Hero
  'hero.title': 'Your Age, Verified.',
  'hero.title2': 'Your Identity, Protected.',
  'hero.subtitle': 'ZK Face는 얼굴을 노출하지 않고도 "만 19세 이상임"만을 검증하는 Zero-Knowledge 기반 인증 기술입니다.',
  'hero.cta.demo': 'Try Full Demo',
  'hero.cta.contact': 'Contact Partnership',
  'hero.ageGuess.title': '나 몇 살로 보이지?',
  'hero.ageGuess.upload': '사진 업로드 해보기',
  'hero.ageGuess.badge': '사진은 서버로 전송되지 않습니다',
  'hero.ageGuess.result': 'AI가 추정한 나이',
  'hero.ageGuess.confidence': '신뢰 구간',
  'hero.ageGuess.privacy1': 'No Storage',
  'hero.ageGuess.privacy2': '100% Local ML',
  'hero.ageGuess.privacy3': 'No Identity Exposure',

  // Problem
  'problem.title': 'The Internet Keeps Asking for Your Identity.',
  'problem.title2': 'But Why Should You Give It Away?',
  'problem.description': '대부분의 온라인 서비스는 여전히 주민번호, 얼굴 원본, 생년월일 같은 고위험 개인정보를 요구하고 있다. 사용자는 불안하고, 서비스 제공자는 과도한 책임을 지게 된다.',
  'problem.point1.title': '개인 정보 유출 리스크',
  'problem.point1.desc': '중앙화된 서버에 저장된 민감한 정보는 항상 해킹의 위험에 노출되어 있습니다.',
  'problem.point2.title': '중앙 서버 저장',
  'problem.point2.desc': '얼굴과 신분 정보가 제3자 서버에 영구적으로 보관됩니다.',
  'problem.point3.title': '글로벌 규제 강화',
  'problem.point3.desc': 'GDPR, CCPA 등 개인정보 보호 규제가 점점 더 엄격해지고 있습니다.',
  'problem.point4.title': 'Web3 비효율성',
  'problem.point4.desc': '레거시 KYC 시스템은 탈중앙화 환경에 적합하지 않습니다.',

  // Solution
  'solution.title': 'Prove Your Age. Reveal Nothing.',
  'solution.description': 'ZK Face는 다음 세 가지 원리를 기반으로 작동합니다.',
  'solution.card1.title': 'Zero-Knowledge Proof',
  'solution.card1.desc': '나이를 증명하지만, 신분 정보를 노출하지 않습니다.',
  'solution.card2.title': 'Local Machine Learning',
  'solution.card2.desc': '얼굴 분석은 전부 사용자 기기에서만 수행됩니다.',
  'solution.card3.title': 'Data-Free Certification',
  'solution.card3.desc': '서버는 어떤 사진도 저장하지 않고 Proof만 확인합니다.',

  // How It Works
  'howItWorks.title': 'How It Works',
  'howItWorks.subtitle': '이 모든 과정은 서버와 얼굴 정보가 단 한 번도 교차하지 않도록 설계되었습니다.',
  'howItWorks.step1.title': '얼굴 촬영',
  'howItWorks.step1.desc': '사용자 로컬 기기에서 이미지가 준비됩니다.',
  'howItWorks.step2.title': 'ML 모델이 특징값 분석',
  'howItWorks.step2.desc': '얼굴을 저장하지 않고, 특징값만 생성합니다.',
  'howItWorks.step3.title': 'ZK-Proof 생성',
  'howItWorks.step3.desc': '장치 내부에서 "이 사용자는 19세 이상이다"라는 증명만 추출됩니다.',
  'howItWorks.step4.title': '서버 검증',
  'howItWorks.step4.desc': 'Proof만 전달되며, 원본 정보는 서버로 넘어오지 않습니다.',

  // Use Cases
  'useCases.title': 'Use Cases',
  'useCases.subtitle': '다양한 산업에서 ZK Face를 활용할 수 있습니다.',
  'useCases.case1.title': 'Adult Verification for Web/Apps',
  'useCases.case1.desc': '웹사이트와 앱에서 성인 인증을 안전하게 처리합니다.',
  'useCases.case2.title': 'Web3 Wallet Login + Age Gate',
  'useCases.case2.desc': '탈중앙화 지갑과 연동된 연령 인증 시스템입니다.',
  'useCases.case3.title': 'Streaming·Gaming Age Control',
  'useCases.case3.desc': '스트리밍과 게임 플랫폼의 연령 제한 기능입니다.',
  'useCases.case4.title': 'Offline Kiosk Verification',
  'useCases.case4.desc': '오프라인 키오스크에서도 안전한 인증이 가능합니다.',
  'useCases.case5.title': 'Government Light-KYC Services',
  'useCases.case5.desc': '정부 서비스를 위한 경량화된 신원 확인 솔루션입니다.',
  'useCases.badge1': 'No Face Storage',
  'useCases.badge2': 'ZKP Verified',

  // Contact
  'contact.title': "Let's Build a Privacy-First Future Together.",
  'contact.subtitle': '파트너십 문의나 기술 관련 질문이 있으시면 언제든 연락주세요.',
  'contact.form.name': '이름',
  'contact.form.email': '이메일',
  'contact.form.company': '회사명',
  'contact.form.message': '메시지',
  'contact.form.submit': '문의하기',
  'contact.form.submitting': '전송 중...',
  'contact.form.success': '문의가 성공적으로 전송되었습니다!',
  'contact.form.error': '전송 중 오류가 발생했습니다. 다시 시도해주세요.',
  'contact.cta.contact': 'Contact Us',
  'contact.cta.deck': 'Download Partnership Deck',

  // Footer
  'footer.description': 'Zero-Knowledge 기반 얼굴 인증 기술로 프라이버시를 보호합니다.',
  'footer.product': '제품',
  'footer.product.features': '기능',
  'footer.product.technology': '기술',
  'footer.product.useCases': '활용 사례',
  'footer.product.demo': '데모',
  'footer.resources': '리소스',
  'footer.resources.docs': '문서',
  'footer.resources.api': 'API',
  'footer.resources.sdk': 'SDK',
  'footer.resources.blog': '블로그',
  'footer.company': '회사',
  'footer.company.about': '회사 소개',
  'footer.company.careers': '채용',
  'footer.company.press': 'Press Kit',
  'footer.company.contact': '문의',
  'footer.legal': '법적 고지',
  'footer.legal.privacy': '개인정보처리방침',
  'footer.legal.terms': '이용약관',
  'footer.legal.security': '보안',
  'footer.copyright': '© 2025 ZK Face. All rights reserved.',
  'footer.poweredBy': 'Website Builder',
};
